import styles from "./SidebarField.module.css";

type ListInSidebarFieldProps = {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
};

export function ListInSidebarField({ id, checked, onChange }: ListInSidebarFieldProps) {
  const hintId = `${id}-hint`;

  return (
    <div className={styles.listingField}>
      <label className={styles.listingLabel} htmlFor={id}>
        <input
          id={id}
          type="checkbox"
          checked={checked}
          onChange={event => onChange(event.target.checked)}
          aria-describedby={hintId}
        />
        List this page in the sidebar
      </label>
      <span id={hintId} className={styles.hint}>
        Untick to keep the sidebar on this page without listing the page in it, e.g. a page linked
        from another page.
      </span>
    </div>
  );
}
